import React from 'react';

export default () => (
    <svg width="43px" height="57px" viewBox="0 0 43 57" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <defs>
            <polygon id="path-1" points="0 2.1875e-05 42.65625 2.1875e-05 42.65625 56 0 56"></polygon>
        </defs>
        <g id="R2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Dashboard-Search-Documents-Patient" transform="translate(-26.000000, -333.000000)">
                <g id="Group-2" transform="translate(26.000000, 333.163767)">
                    <g id="Group-8-Copy">
                        <g id="Group-3">
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#path-1"></use>
                            </mask>
                            <g id="Clip-2"></g>
                            <path d="M42.65625,14.7656469 L31.171875,11.4843969 L27.890625,2.1875e-05 L4.921875,2.1875e-05 C2.20357813,2.1875e-05 0,2.2036 0,4.92189688 L0,51.0781469 C0,53.7964438 2.20357813,56.0000219 4.921875,56.0000219 L37.734375,56.0000219 C40.4526719,56.0000219 42.65625,53.7964438 42.65625,51.0781469 L42.65625,14.7656469 Z" id="Fill-1" fill="#F3EDE6" mask="url(#mask-2)"></path>
                        </g>
                        <path d="M42.65625,14.7656469 L31.171875,14.7656469 C29.3671875,14.7656469 27.890625,13.2890844 27.890625,11.4843969 L27.890625,2.1875e-05 C28.3171875,2.1875e-05 28.74375,0.164084375 29.0389531,0.49231875 L42.1639531,13.6173188 C42.4921875,13.9125219 42.65625,14.3390844 42.65625,14.7656469" id="Fill-4" fill="#EADCCE"></path>
                    </g>
                    <text id=".jpg" fontFamily="Montserrat-Medium, Montserrat" fontSize="10" fontWeight="400" fill="#353535">
                        <tspan x="11.5" y="44.1637668">.jpg</tspan>
                    </text>
                </g>
            </g>
        </g>
    </svg>
    
);
